export enum CalculationCloseReasonEnum {
  CostumerNoResponse = 'costumerNoResponse',
  CostumerNoInterested = 'costumerNoInterested',
  CustomerInformationIncorrect = 'customerInformationIncorrect',
  CustomerPhotosIncorrect = 'customerPhotosIncorrect',
  UnforeseeableAdditionalWork = 'unforeseeableAdditionalWork',
  Miscellaneous = 'miscellaneous',
}
